import React from 'react'
import 'react-spring-bottom-sheet/dist/style.css'
import FindMySponsor from 'src/onboarding/components/FindMySponsor'
import { Dialog as DSDialog } from 'src/design_system/molecules/dialog/Dialog'
type SponsorSearchWindowProps = {
  isOpen: boolean
  onSelectSponsor: (sponsorId: string, genealogyId: string) => void
  isAffiliateJoining: boolean
  mobileBreakPoint?: number
  onClose: () => void
}

export const SponsorSearchWindow = (props: SponsorSearchWindowProps) => {
  const {
    isOpen,
    isAffiliateJoining,
    onSelectSponsor,
    mobileBreakPoint = 754,
    onClose,
  } = props
  return (
    <>
      <DSDialog
        isOpen={isOpen}
        onClose={onClose}
        mobileBreakPointOverride={mobileBreakPoint}
        maxWidth="630px"
        sheetBgColorOverride="#fff"
      >
        <FindMySponsor
          onChooseSponsor={onSelectSponsor}
          isAffiliateJoining={isAffiliateJoining}
        />
      </DSDialog>
    </>
  )
}
